"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    default: function() {
        return _default;
    },
    getByKey: function() {
        return getByKey;
    },
    modify: function() {
        return modify;
    },
    unpackImageInfo: function() {
        return _unpackImageInfo.default;
    }
});
const _enums = require("../enums");
const _unpackImageInfo = /*#__PURE__*/ _interop_require_default(require("../utils/unpackImageInfo.js"));
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function getByKey(key = "", imageInfo = {}, frameIndex = 0) {
    let value = {};
    if (!Object.values(_enums.ImageInfoKeys).includes(key)) {
        console.error(`Invalid Key: ${key} is not a valid key in ImageInfoKeys.`);
        return value;
    }
    if ((key === _enums.ImageInfoKeys.THERMAL_IMAGE_INFO_DATA || key === _enums.ImageInfoKeys.VL_IMAGE_METADATA) && Array.isArray(imageInfo[key])) {
        var _imageInfo_key;
        var _imageInfo_key_frameIndex;
        value = (_imageInfo_key_frameIndex = (_imageInfo_key = imageInfo[key]) === null || _imageInfo_key === void 0 ? void 0 : _imageInfo_key[frameIndex]) !== null && _imageInfo_key_frameIndex !== void 0 ? _imageInfo_key_frameIndex : {};
    } else {
        var _imageInfo_key1;
        value = (_imageInfo_key1 = imageInfo[key]) !== null && _imageInfo_key1 !== void 0 ? _imageInfo_key1 : {};
    }
    return value;
}
function modify(key = "", value = {}, imageInfo) {
    let nextImageInfo = {};
    if (Object.keys(value).length > 0 && Object.values(_enums.ImageInfoKeys).includes(key)) {
        nextImageInfo = _object_spread_props(_object_spread({}, imageInfo), {
            [key]: _object_spread({}, imageInfo[key], value)
        });
    }
    return nextImageInfo;
}
const imageInfoHandler = {
    getByKey,
    modify
};
const _default = imageInfoHandler;
